import React from "react";
import "./styles/featurebox.css";
const FeatureBox = ({minWboxWidth,gap, boxWidth ,titleFontSize,paraColor, imgSrc, title, content,transparent,headingColor }) => {
  return (
    <div className="feature-box" style={{
      width:boxWidth && (boxWidth),
      background:transparent && ("transparent"),
      minWidth:minWboxWidth && minWboxWidth,
      gap:gap&&gap
    }}>
      <div className="feature-box-img">
        <img style={{transform:"scale(2.3)"}} src={imgSrc || '/images/arrow.svg'} alt="" />
      </div>
      <h3 className="box-title" style={{
        color:headingColor,
        fontSize:titleFontSize && (titleFontSize)
      }}>{title}</h3>
      <p style={{
        color:paraColor && (paraColor)
      }} className="feature-box-para">{content}</p>
    </div>
  );
};

export default FeatureBox;
